import type { IAppTooltipProps } from './helpers';

export const AppTooltip = ({ variant, ...rest }: IAppTooltipProps) => {
	if (variant === 'dashboard')
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					fill='#D8F9FF'
				/>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					stroke='#2FB1CA'
					strokeWidth='0.342857'
				/>
				<path
					d='M43.8145 22.7854C42.9002 19.6854 40.3145 17.0997 37.2145 16.1854C34.8574 15.4997 33.2288 15.5569 32.1002 16.3997C30.7431 17.414 30.5859 19.2426 30.5859 20.5426V24.0997C30.5859 27.614 32.1859 29.3997 35.3288 29.3997H39.4288C40.7145 29.3997 42.5574 29.2426 43.5717 27.8854C44.4431 26.7712 44.5145 25.1426 43.8145 22.7854Z'
					fill='#2FB1CA'
				/>
				<path
					opacity='0.4'
					d='M39.8718 31.9422C39.5003 31.5137 38.9575 31.2708 38.4003 31.2708H33.2861C30.7718 31.2708 28.7289 29.2279 28.7289 26.7137V21.5994C28.7289 21.0422 28.4861 20.4994 28.0575 20.1279C27.6432 19.7565 27.0718 19.5851 26.5289 19.6565C23.1718 20.0851 20.0861 21.9279 18.0718 24.6994C16.0432 27.4851 15.3003 30.8851 15.9432 34.2851C16.8718 39.1994 20.8003 43.1279 25.7289 44.0565C26.5146 44.2137 27.3003 44.2851 28.0861 44.2851C30.6718 44.2851 33.1718 43.4851 35.3003 41.9279C38.0718 39.9137 39.9146 36.8279 40.3432 33.4708C40.4146 32.9137 40.2432 32.3565 39.8718 31.9422Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'wallet')
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					fill='#D8F9FF'
				/>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					stroke='#2FB1CA'
					strokeWidth='0.342857'
				/>
				<path
					opacity='0.4'
					d='M44.2853 30.0003V37.1431C44.2853 41.4289 41.4282 44.286 37.1424 44.286H22.8567C18.571 44.286 15.7139 41.4289 15.7139 37.1431V30.0003C15.7139 26.1146 18.0567 23.4003 21.6996 22.9431C22.071 22.886 22.4567 22.8574 22.8567 22.8574H37.1424C37.5139 22.8574 37.871 22.8717 38.2139 22.9288C41.8996 23.3574 44.2853 26.086 44.2853 30.0003Z'
					fill='#05A2BF'
				/>
				<path
					d='M38.2145 22.9291C37.8716 22.872 37.5145 22.8577 37.1431 22.8577H22.8573C22.4573 22.8577 22.0716 22.8863 21.7002 22.9434C21.9002 22.5434 22.1859 22.172 22.5288 21.8291L27.1716 17.172C29.1288 15.2291 32.3002 15.2291 34.2573 17.172L36.7573 19.7006C37.6716 20.6006 38.1573 21.7434 38.2145 22.9291Z'
					fill='#05A2BF'
				/>
				<path
					d='M44.2854 30.7148H39.9997C38.4283 30.7148 37.1426 32.0006 37.1426 33.572C37.1426 35.1434 38.4283 36.4291 39.9997 36.4291H44.2854'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'addresses')
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					fill='#D8F9FF'
				/>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					stroke='#2FB1CA'
					strokeWidth='0.342857'
				/>
				<path
					opacity='0.8'
					d='M31.2856 16.457L31.2428 16.557L27.0999 26.1713H23.0285C22.0571 26.1713 21.1428 26.357 20.2856 26.7284L22.7856 20.757L22.8428 20.6284L22.9285 20.3998C22.9714 20.2998 22.9999 20.2141 23.0428 20.1427C24.9142 15.8141 27.0285 14.8284 31.2856 16.457Z'
					fill='#05A2BF'
				/>
				<path
					d='M38.9853 26.457C38.3425 26.2713 37.671 26.1713 36.971 26.1713H27.0996L31.2425 16.557L31.2853 16.457C31.4853 16.5285 31.6996 16.6285 31.9139 16.6999L35.071 18.0285C36.8282 18.757 38.0568 19.5142 38.8139 20.4285C38.9425 20.5999 39.0568 20.757 39.171 20.9427C39.2996 21.1427 39.3996 21.3427 39.4568 21.557C39.5139 21.6856 39.5567 21.7999 39.5853 21.9285C39.9567 23.1427 39.7282 24.6142 38.9853 26.457Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.4'
					d='M43.9428 33.1433V35.929C43.9428 36.2147 43.9286 36.5004 43.9143 36.7719C43.6428 41.7719 40.8571 44.2862 35.5714 44.2862H24.4286C24.0714 44.2862 23.7428 44.2576 23.4143 44.2147C18.8714 43.9147 16.4428 41.4862 16.1286 36.9433C16.0857 36.6004 16.0571 36.2719 16.0571 35.929V33.1433C16.0571 30.2719 17.8 27.8004 20.2857 26.729C21.1428 26.3576 22.0571 26.1719 23.0286 26.1719H36.9714C37.6714 26.1719 38.3428 26.2719 38.9857 26.4576C41.8428 27.329 43.9428 29.9862 43.9428 33.1433Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.6'
					d='M22.7857 20.7578L20.2857 26.7292C17.8 27.8007 16.0571 30.2721 16.0571 33.1435V28.9578C16.0571 24.9007 18.9428 21.515 22.7857 20.7578Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.6'
					d='M43.9425 28.9566V33.1424C43.9425 29.9852 41.8425 27.3281 38.9854 26.4566C39.7282 24.6138 39.9568 23.1424 39.5853 21.9281C39.5568 21.7995 39.5139 21.6852 39.4568 21.5566C42.1282 22.9424 43.9425 25.7566 43.9425 28.9566Z'
					fill='#05A2BF'
				/>
				<path
					d='M33.5712 33.8431H31.0712V31.4289C31.0712 30.8431 30.5855 30.3574 29.9998 30.3574C29.4141 30.3574 28.9284 30.8431 28.9284 31.4289V33.8431H26.4284C25.8426 33.8431 25.3569 34.3289 25.3569 34.9146C25.3569 35.5003 25.8426 35.986 26.4284 35.986H28.9284V38.5717C28.9284 39.1574 29.4141 39.6431 29.9998 39.6431C30.5855 39.6431 31.0712 39.1574 31.0712 38.5717V35.986H33.5712C34.1569 35.986 34.6426 35.5003 34.6426 34.9146C34.6426 34.3289 34.1569 33.8431 33.5712 33.8431Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'transactions')
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					fill='#D8F9FF'
				/>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					stroke='#2FB1CA'
					strokeWidth='0.342857'
				/>
				<path
					opacity='0.4'
					d='M22.4716 41.0006C23.643 39.7434 25.4287 39.8434 26.4573 41.2148L27.9002 43.1434C29.0573 44.672 30.9287 44.672 32.0859 43.1434L33.5287 41.2148C34.5573 39.8434 36.343 39.7434 37.5144 41.0006C40.0573 43.7148 42.1287 42.8148 42.1287 39.0148V22.9148C42.1287 17.1577 40.7859 15.7148 35.3859 15.7148H24.5859C19.1859 15.7148 17.843 17.1577 17.843 22.9148V39.0006C17.8573 42.8148 19.943 43.7006 22.4716 41.0006Z'
					fill='#05A2BF'
				/>
				<path
					d='M33.9286 28.2151H26.0714C25.4857 28.2151 25 27.7294 25 27.1437C25 26.558 25.4857 26.0723 26.0714 26.0723H33.9286C34.5143 26.0723 35 26.558 35 27.1437C35 27.7294 34.5143 28.2151 33.9286 28.2151Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'withdrawals')
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					fill='#D8F9FF'
				/>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					stroke='#2FB1CA'
					strokeWidth='0.342857'
				/>
				<path
					opacity='0.8'
					d='M31.2856 16.457L31.2428 16.557L27.0999 26.1713H23.0285C22.0571 26.1713 21.1428 26.357 20.2856 26.7284L22.7856 20.757L22.8428 20.6284L22.9285 20.3998C22.9714 20.2998 22.9999 20.2141 23.0428 20.1427C24.9142 15.8141 27.0285 14.8284 31.2856 16.457Z'
					fill='#05A2BF'
				/>
				<path
					d='M38.9853 26.457C38.3425 26.2713 37.671 26.1713 36.971 26.1713H27.0996L31.2425 16.557L31.2853 16.457C31.4853 16.5285 31.6996 16.6285 31.9139 16.6999L35.071 18.0285C36.8282 18.757 38.0568 19.5142 38.8139 20.4285C38.9425 20.5999 39.0568 20.757 39.171 20.9427C39.2996 21.1427 39.3996 21.3427 39.4568 21.557C39.5139 21.6856 39.5567 21.7999 39.5853 21.9285C39.9567 23.1427 39.7282 24.6142 38.9853 26.457Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.4'
					d='M43.9428 33.1433V35.929C43.9428 36.2147 43.9286 36.5004 43.9143 36.7719C43.6428 41.7719 40.8571 44.2862 35.5714 44.2862H24.4286C24.0714 44.2862 23.7428 44.2576 23.4143 44.2147C18.8714 43.9147 16.4428 41.4862 16.1286 36.9433C16.0857 36.6004 16.0571 36.2719 16.0571 35.929V33.1433C16.0571 30.2719 17.8 27.8004 20.2857 26.729C21.1428 26.3576 22.0571 26.1719 23.0286 26.1719H36.9714C37.6714 26.1719 38.3428 26.2719 38.9857 26.4576C41.8428 27.329 43.9428 29.9862 43.9428 33.1433Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.6'
					d='M22.7857 20.7578L20.2857 26.7292C17.8 27.8007 16.0571 30.2721 16.0571 33.1435V28.9578C16.0571 24.9007 18.9428 21.515 22.7857 20.7578Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.6'
					d='M43.9425 28.9566V33.1424C43.9425 29.9852 41.8425 27.3281 38.9854 26.4566C39.7282 24.6138 39.9568 23.1424 39.5853 21.9281C39.5568 21.7995 39.5139 21.6852 39.4568 21.5566C42.1282 22.9424 43.9425 25.7566 43.9425 28.9566Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'analytics')
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					fill='#D8F9FF'
				/>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					stroke='#2FB1CA'
					strokeWidth='0.342857'
				/>
				<path
					d='M35.9858 15.7148H24.0144C18.8144 15.7148 15.7144 18.8148 15.7144 24.0148V35.9863C15.7144 41.1863 18.8144 44.2863 24.0144 44.2863H35.9858C41.1858 44.2863 44.2858 41.1863 44.2858 35.9863V24.0148C44.2858 18.8148 41.1858 15.7148 35.9858 15.7148ZM23.9286 32.2863C23.9286 32.872 23.4429 33.3577 22.8572 33.3577C22.2715 33.3577 21.7858 32.872 21.7858 32.2863V27.7148C21.7858 27.1291 22.2715 26.6434 22.8572 26.6434C23.4429 26.6434 23.9286 27.1291 23.9286 27.7148V32.2863ZM31.0715 34.772C31.0715 35.3577 30.5858 35.8434 30.0001 35.8434C29.4144 35.8434 28.9286 35.3577 28.9286 34.772V25.2291C28.9286 24.6434 29.4144 24.1577 30.0001 24.1577C30.5858 24.1577 31.0715 24.6434 31.0715 25.2291V34.772ZM38.2144 32.2863C38.2144 32.872 37.7286 33.3577 37.1429 33.3577C36.5572 33.3577 36.0715 32.872 36.0715 32.2863V27.7148C36.0715 27.1291 36.5572 26.6434 37.1429 26.6434C37.7286 26.6434 38.2144 27.1291 38.2144 27.7148V32.2863Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'developer-business' || variant === 'developer-integration' || variant === 'developer-webhook-logs')
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					fill='#D8F9FF'
				/>
				<rect
					x='0.171429'
					y='0.171429'
					width='59.6571'
					height='59.6571'
					rx='29.8286'
					stroke='#2FB1CA'
					strokeWidth='0.342857'
				/>
				<path
					opacity='0.4'
					d='M44.2853 24.2852V35.9852C44.2853 41.1852 41.1853 44.2852 35.9853 44.2852H24.0139C18.8139 44.2852 15.7139 41.1852 15.7139 35.9852V24.2994L44.2853 24.2852Z'
					fill='#05A2BF'
				/>
				<path
					d='M25.714 38.2152C25.5569 38.2152 25.3854 38.1723 25.2426 38.1009C24.1426 37.5437 23.1997 36.7152 22.514 35.6866C21.9426 34.8294 21.9426 33.7294 22.514 32.8723C23.1997 31.8437 24.1426 31.0152 25.2426 30.4723C25.7712 30.2009 26.414 30.4294 26.6854 30.958C26.9569 31.4866 26.7426 32.1294 26.1997 32.4009C25.4283 32.7866 24.7712 33.3723 24.2997 34.0866C24.214 34.2152 24.214 34.3866 24.2997 34.5294C24.7712 35.2437 25.4283 35.8294 26.1997 36.2152C26.7283 36.4866 26.9426 37.1294 26.6854 37.658C26.4854 38.0009 26.0997 38.2152 25.714 38.2152Z'
					fill='#05A2BF'
				/>
				<path
					d='M34.5853 38.214C34.1853 38.214 33.8139 37.9997 33.6282 37.6283C33.3568 37.0997 33.571 36.4569 34.1139 36.1855C34.8853 35.7997 35.5425 35.214 36.0139 34.4997C36.0996 34.3712 36.0996 34.1997 36.0139 34.0569C35.5425 33.3426 34.8853 32.7569 34.1139 32.3712C33.5853 32.0997 33.371 31.4569 33.6282 30.9283C33.8996 30.3997 34.5425 30.1855 35.071 30.4426C36.171 30.9997 37.1139 31.8283 37.7996 32.8569C38.371 33.714 38.371 34.814 37.7996 35.6712C37.1139 36.6997 36.171 37.5283 35.071 38.0712C34.8996 38.1712 34.7425 38.214 34.5853 38.214Z'
					fill='#05A2BF'
				/>
				<path
					d='M44.2853 24.0148V24.2863L15.7139 24.3006V24.0148C15.7139 18.8148 18.8139 15.7148 24.0139 15.7148H35.9853C41.1853 15.7148 44.2853 18.8148 44.2853 24.0148Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	return (
		<svg
			width='60'
			height='60'
			viewBox='0 0 60 60'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				x='0.171429'
				y='0.171429'
				width='59.6571'
				height='59.6571'
				rx='29.8286'
				fill='#D8F9FF'
			/>
			<rect
				x='0.171429'
				y='0.171429'
				width='59.6571'
				height='59.6571'
				rx='29.8286'
				stroke='#2FB1CA'
				strokeWidth='0.342857'
			/>
			<path
				opacity='0.4'
				d='M15.7139 31.2569V28.7426C15.7139 27.2569 16.9282 26.0283 18.4282 26.0283C21.0139 26.0283 22.071 24.1998 20.771 21.9569C20.0282 20.6712 20.471 18.9998 21.771 18.2569L24.2424 16.8426C25.371 16.1712 26.8282 16.5712 27.4996 17.6998L27.6567 17.9712C28.9424 20.2141 31.0567 20.2141 32.3567 17.9712L32.5139 17.6998C33.1853 16.5712 34.6424 16.1712 35.771 16.8426L38.2424 18.2569C39.5424 18.9998 39.9853 20.6712 39.2424 21.9569C37.9424 24.1998 38.9996 26.0283 41.5853 26.0283C43.071 26.0283 44.2996 27.2426 44.2996 28.7426V31.2569C44.2996 32.7426 43.0853 33.9712 41.5853 33.9712C38.9996 33.9712 37.9424 35.7998 39.2424 38.0426C39.9853 39.3426 39.5424 40.9998 38.2424 41.7426L35.771 43.1569C34.6424 43.8283 33.1853 43.4283 32.5139 42.2998L32.3567 42.0283C31.071 39.7855 28.9567 39.7855 27.6567 42.0283L27.4996 42.2998C26.8282 43.4283 25.371 43.8283 24.2424 43.1569L21.771 41.7426C20.471 40.9998 20.0282 39.3283 20.771 38.0426C22.071 35.7998 21.0139 33.9712 18.4282 33.9712C16.9282 33.9712 15.7139 32.7426 15.7139 31.2569Z'
				fill='#05A2BF'
			/>
			<path
				d='M29.9998 34.6431C32.564 34.6431 34.6426 32.5645 34.6426 30.0003C34.6426 27.4361 32.564 25.3574 29.9998 25.3574C27.4356 25.3574 25.3569 27.4361 25.3569 30.0003C25.3569 32.5645 27.4356 34.6431 29.9998 34.6431Z'
				fill='#05A2BF'
			/>
		</svg>
	);
};
